const apiURL = 'https://admin.prepress24.pl/shop-api/';
// const apiURL = 'http://localhost:8081/shop-api/';
const paymentURL = 'https://sandbox.przelewy24.pl/api/v1/';
const projectName = 'Prepress24.pl';
const validateMessages = {
    group: 'results',
    error: {
        header: 'Wystąpił błąd',
        text: 'Nie udało się wykonać akcji.<br>Zgłoś błąd do administracji.'
    },
    success: {
        header: 'Udało się!'
    },
};

export {
    apiURL,
    paymentURL,
    validateMessages,
    projectName
};
